import dayjs from 'dayjs';
import styled from 'styled-components';

import InfoIcon from '@/components/atom/icon/InfoIcon';
import theme from '@/styles/theme';
import { AnswererType, QnaDetailVo } from '@/types/qna';

interface Props {
  answer: QnaDetailVo['answers'][0];
}
const AnswerFootnote = ({ answer }: Props) => {
  return (
    <>
      {answer.answerer.answererType === AnswererType.Ai ? (
        <AiAnswerGuide>
          <p>
            <InfoIcon color={theme.color.blue500} />꼭 확인해주세요.
          </p>
          <ul>
            <li>첨부된 이미지를 제외하고 해석한 답변이에요.</li>
            <li>
              본 답변은 의학적 판단이나 진료 행위로 해석될 수 없으며, 닥터나우는
              이로 인해 발생하는 어떠한 책임도 지지 않습니다.
            </li>
            <li>
              정확한 개인 증상 파악 및 진단은 의료 기관 내방을 통해 진행하시기
              바랍니다.
            </li>
            <li>
              고객님의 개인정보 보호를 위해 개인정보는 입력하지 않도록 주의
              바랍니다.
            </li>
            <li>서비스에 입력되는 데이터는 OpenAI 정책에 따라 관리됩니다.</li>
          </ul>
        </AiAnswerGuide>
      ) : (
        <AnswerGuide>
          <ul>
            {dayjs(answer.createdAt).isBefore('2023-06-02') && (
              <li>
                비대면 진료 관련 정부 정책이 변경되어, 일부 환자만 비대면 진료와
                약 배송 서비스를 이용할 수 있습니다. 자세한 내용은 공지 참고
                부탁드립니다.
              </li>
            )}
            <li>
              {`'실시간 의료상담' 에서의 답변은 의료진의 경험과 지식을 바탕으로 한 참고용 정보 제공입니다. 정확한 개인 증상 파악 및 진단은 의료기관 내방을 통해 진행하시기 바랍니다.`}
            </li>
          </ul>
        </AnswerGuide>
      )}
    </>
  );
};

export default AnswerFootnote;

const GuideWrapper = styled.div`
  padding-top: 24px;

  ${({ theme }) => `
    & > ul {
      & > li {
        ${theme.typography.UI12R};
        color: ${theme.color.gray300};
        position: relative;
        padding-left: 22px;

        &:before {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: ${theme.color.gray300};
          display: block;
          position: absolute;
          left: 7px;
          top: 7px;
        }
      }
    }
  `}
`;
const AnswerGuide = styled(GuideWrapper)`
  & > p {
    margin-bottom: 12px;
  }
`;

const AiAnswerGuide = styled(GuideWrapper)`
  display: flex;
  flex-direction: column;

  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.blue500};
  `};

  & > p {
    display: flex;
    align-items: center;
    padding-bottom: 8px;

    & > svg {
      margin-right: 6px;
    }
  }
`;
